export const mix = (value1: number, value2: number, percent: number): number =>
  value1 * (1 - percent) + value2 * percent;

export const smoothstep = (min: number, max: number, value: number): number =>
  Math.max(0, Math.min(1, (value - min) / (max - min)));

export const lerp = (value1: number, value2: number, time: number): number =>
  value1 + time * (value2 - value1);

export const map = (value: number, min: number, max: number): number =>
  clamp((value - min) / (max - min), min, max);

export const clamp = (value: number, min = 0.0, max = 1.0): number =>
  Math.max(min, Math.min(value, max));

export const randomInt = (min: number, max: number): number =>
  ((Math.random() * (max - min + 1)) | 0) + min;

export const random = (min: number, max: number): number =>
  Math.random() * (max - min) + min;

export const toFixed = (value: number, mantissa = 2.0) => {
  const pow10 = Math.pow(10, mantissa);
  return ~~(pow10 * value) / pow10;
};

export const saturate = (x: number): number => clamp(x);

export const PHI = Math.sqrt(5.0) * 0.5 + 0.5;

export const DELTA_UPDATE = 1.0 / 0.06;
export const DELTA_FRAME = 1.0 / 60.0;

export const RAD = Math.PI * 0.5;
export const TAU = Math.PI * 2.0;

export class Elastic {
  private current: number;
  private target: number;
  public speed = 10;

  public constructor(value: number) {
    this.target = this.current = value;
  }

  public update(delta: number = DELTA_FRAME): void {
    const dist = this.target - this.current;
    this.current += dist * (this.speed * delta);
  }

  public set(target: number): void {
    this.target = target;
  }

  public get value(): number {
    return this.current;
  }
}
